import React from 'react';
import { useDispatch } from 'react-redux';
import { submit } from 'redux-form';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import classnames from 'classnames';

import { InputRow } from '../inputs';
import Button from '../inputs/Button';

import styles from './modal.module.scss';

export const Modal = ({
  title,
  titleClassName,
  isOpen,
  children,
  onRequestClose,
  submitActions,
  disableSubmit,
  submitButtonColor,
  submitButtonText,
  hideCancelButton,
  cancelButtonText,
  cancelButtonColor,
  hideButtons,
  cancelActions,
  formName,
  testID,
  wide,
  medium,
  className,
  disableCancel,
  tall,
  taller,
  hideSubmitButton,
  onMouseEnter,
  submitTooltip,
  modalMediumTall
}) => {
  const dispatch = useDispatch();
  const handleSubmit =
    submitActions ?? (formName ? () => dispatch(submit(formName)) : () => {});

  return (
    <div>
      <div
        className={classnames(
          styles.modal,
          className,
          !isOpen && styles.modalHide
        )}
      >
        <section
          className={classnames(
            styles.modalBody,
            wide && styles.modalWide,
            medium && styles.modalMedium
          )}
        >
          <h2
            className={classnames(
              styles.modalBodyHeader,
              titleClassName && styles[titleClassName]
            )}
          >
            <span
              className={classnames(
                styles.modalBodyHeaderText,
                titleClassName && styles[titleClassName]
              )}
            >
              {title}
            </span>
            <div
              onClick={onRequestClose}
              className={styles.modalBodyHeaderX}
              data-cy={`${testID}CloseModalButton`}
            >
              <img
                src={require('../../assets/images/modalX.png')}
                alt="close the modal"
              />
            </div>
          </h2>
          <section
            className={classnames(
              hideButtons
                ? styles.modalBodyContentHideButtons
                : styles.modalBodyContent,
              tall && styles.modalTall,
              taller && styles.modalTaller,
              modalMediumTall && styles.modalMediumTall
            )}
          >
            {typeof children === 'string' ? (
              <div className={styles.childText}>{children}</div>
            ) : (
              children
            )}
          </section>
          {!hideButtons ? (
            <footer className={styles.modalBodyFooter}>
              <InputRow>
                {!hideSubmitButton ? (
                  <span data-tip data-tooltip-id="submitTooltip">
                    <Button
                      testID={`${testID}SubmitButton`}
                      text={submitButtonText || 'Submit'}
                      color={submitButtonColor}
                      onClick={handleSubmit}
                      disabled={disableSubmit}
                      onMouseEnter={onMouseEnter}
                      inputClassName={
                        submitTooltip ? styles.modalBodyFooterCannotSubmit : ''
                      }
                    />
                    {submitTooltip ? (
                      <ReactTooltip id="submitTooltip" key="submitTooltip">
                        {submitTooltip}
                      </ReactTooltip>
                    ) : null}
                  </span>
                ) : null}
                {!hideCancelButton ? (
                  <Button
                    onClick={cancelActions ? cancelActions : onRequestClose}
                    text={cancelButtonText || 'Cancel'}
                    color={cancelButtonColor || 'white'}
                    disabled={disableCancel}
                  />
                ) : null}
              </InputRow>
            </footer>
          ) : null}
        </section>
      </div>
    </div>
  );
};

export default Modal;
